define('modules/page_listing/models/page_stats',['require','exports','module','backbone','env'],function(reequire, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  var PageStats = Backbone.Model.extend({
    urlRoot: config.apiHost + "/pages/stats"
  });

  module.exports = PageStats;

});
